import { useCurrentStateAndParams } from "@uirouter/react";
import { KeywordAnalysisPositionNACall } from "app/components/React/Table/cells/KeywordAnalysisPositionNACall";
import { KeywordAnalysisPosition } from "app/components/React/Table/cells";

export const MobileV2TableKeywordPositionCall = ({ params }: FixmeType) => {
    const country = useCurrentStateAndParams().params.country;
    const isWWO = country === "999";
    if (isWWO) {
        return <KeywordAnalysisPositionNACall {...params} />;
    } else {
        return <KeywordAnalysisPosition {...params} />;
    }
};
